<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      isButtonActive: true,
    };
  },
  computed: {
    app_section() {
      return this.$store.getters.get_app_section;
    },
  },
  methods: {
    submit() {
      const data = {
        email: this.email,
        password: this.password,
      };

      this.isButtonActive = false;

      this.$store.dispatch('LOGIN', data)
        .then(() => {
          this.$router.push({ name: this.app_section });
        })
        .catch((error) => {
          if (error.message === 'Account is not verified') {
            this.registered = true;

            this.$store.dispatch('nt_set_notification', {
              type: 'message',
              message: 'Your account will be activated soon.',
            });

            return;
          }

          this.$store.dispatch('nt_set_notification', {
            type: 'error',
            message: 'Unknown error. Please try again.',
          });

          console.error('Error:', error);
          console.log('Response:', error.response);
        })
        .finally(() => { this.isButtonActive = true; });
    },
  },
};
</script>
<template src="./sign_in.pug" lang="pug"></template>
<style src="./sign_in.styl" lang="stylus" scoped></style>
